<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import { USERSPATH } from "../../../../../path";
import axios from "axios";
import add from "./add";
import permissions from "./permissions";
import Swal from "sweetalert2";
import ListIcon from "@/views/pages/Dilfoods/Common/icons/ListIcon.vue";
import EditIcon from "@/views/pages/Dilfoods/Common/icons/EditIcon.vue";
import DeleteIcon from "@/views/pages/Dilfoods/Common/icons/DeleteIcon.vue";

export default {
  components: {
    Layout,
    PageHeader,
    add,
    permissions,
    ListIcon,
    EditIcon,
    DeleteIcon,
  },
  data() {
    return {
      title: "Users",
      items: [
        {
          text: "List",
        },
        {
          text: "Users",
          active: true,
        },
      ],
      filter: [],
      key: 0,
      selectedUser: {},
      users: [],
      currentPage: 1,
      search: "",
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      set_role: "Others",
      fields: ["name", "email", "role", "permission", "actions"],
    };
  },

  watch: {
    search() {
      this.getUsers();
    },
    currentPage() {
      this.getUsers();
    },
  },
  methods: {
    addUser() {
      this.$bvModal.show("bv-add-user");
      this.selectedUser = {};
      this.key += 1;
    },
    editUser(v) {
      this.selectedUser = v;
      this.$bvModal.show("bv-add-user");
      this.key += 1;
    },
    setRestaurants(v) {
      this.selectedUser = v;
      this.$bvModal.show("set-restaurants");
    },
    async getUsers() {
      try {
        let response = await axios.get(
          this.base_url + USERSPATH.GET_ACCOUNTMANAGET_USERS,
          {
            params: {
              page: this.currentPage,
              search: this.search,
              role: this.set_role,
            },
          }
        );
        if (response.data.status == true) {
          this.users = response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    reload() {
      this.$bvModal.hide("bv-add-user");
      this.$bvModal.hide("bv-show-permissions");
      this.getUsers();
    },
    setEdit(d) {
      this.selectedUser = d;
      this.$bvModal.show("bv-add-user");
    },
    showPermissions(v) {
      this.selectedUser = v;
      this.$bvModal.show("bv-show-permissions");
    },
    setRole(v) {
      this.set_role = v;
      this.getUsers();
    },
    async deleteData(v) {
      try {
        let res = await axios.post(this.base_url + USERSPATH.DELETE_USER, {
          user_id: v.id,
        });
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.getUsers();
        } else {
          throw new Error(res.data.message);
        }
      } catch (error) {
        console.log(error);
        Swal.fire(error.message, "", "error");
      }
    },
  },
  mounted() {
    this.getUsers();
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-6">
                <b-button @click="addUser()" class="btn btn-primary mb-10 pb-10"
                  >Add User</b-button
                >
                <b-modal
                  id="bv-add-user"
                  size="xl"
                  :title="
                    (Object.keys(selectedUser).length > 0 ? 'Edit' : 'Add') +
                    ' User'
                  "
                  hide-footer
                >
                  <add @update="reload()" :selectedUser="selectedUser"></add>
                </b-modal>
                <b-modal
                  id="bv-show-permissions"
                  size="xl"
                  :title="'Permissions'"
                  hide-footer
                >
                  <permissions
                    @update="reload()"
                    :permissions="selectedUser.permissions"
                    :user="selectedUser"
                  ></permissions>
                </b-modal>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center mr-5">
                    Search:
                    <b-form-input
                      v-model="search"
                      type="search"
                      debounce="300"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <b-tabs>
              <b-tab
                title="Restaurant Partners"
                :active="set_role == 'RestaurantPartner'"
                @click="setRole('RestaurantPartner')"
              ></b-tab>
              <b-tab
                title="Users"
                :active="set_role == 'Others'"
                @click="setRole('Others')"
              ></b-tab>
            </b-tabs>
            <div class="table-responsive mb-0">
              <b-table
                :key="users.key"
                :items="users.data"
                :fields="fields"
                responsive="sm"
                :filter="filter"
                :current-page="currentPage"
              >
                <template v-slot:cell(restaurants)="row">
                  <b-button
                    variant="primary"
                    v-if="
                      row.item.roles[0].name.includes(
                        'AccountManagers',
                        'Chefs'
                      )
                    "
                    @click="setRestaurants"
                    ><i class="fa fa-list"></i
                  ></b-button>
                </template>
                <template v-slot:cell(role)="row">
                  {{ row.item.roles.length > 0 ? row.item.roles[0].name : "" }}
                </template>
                <template v-slot:cell(actions)="row">
                  <div style="display: flex; gap: 0px">
                    <div
                      v-if="
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name == 'SuperAdmin'
                        ).length > 0 ||
                        $store.state.authfack.user.permissions.filter(
                          (f) => f.name == 'Users'
                        ).length > 0
                      "
                      @click="setEdit(row.item)"
                    >
                      <EditIcon />
                    </div>
                    <div
                      v-if="
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name == 'SuperAdmin'
                        ).length > 0 ||
                        $store.state.authfack.user.permissions.filter(
                          (f) => f.name == 'Users'
                        ).length > 0
                      "
                      @click="deleteData(row.item)"
                    >
                      <DeleteIcon />
                    </div>
                  </div>
                </template>
                <template v-slot:cell(permission)="row">
                  <div style="display: flex; gap: 0px">
                    <div @click="showPermissions(row.item)">
                      <ListIcon variant="primary" />
                    </div>
                  </div>
                  <!-- <b-button
                    variant="primary"
                    @click="showPermissions(row.item)"
                  >
                    <i class="fa fa-list"></i>
                  </b-button> -->
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="users.key"
                      v-model="currentPage"
                      :total-rows="users.total"
                      :per-page="users.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style></style>
